import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollEHTEarningsSetup } from "../../components/PayrollEHTEarningsSetup";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollWCBWSIBEarningsSetup } from "../../components/PayrollWCBWSIBEarningsSetup";

export const PayrollEHTEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll EHT Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll EHT Earnings", navigateTo: "/company/payrollEHTEarnings/setup" }
      ]}
      mainContents={<PayrollEHTEarningsSetup />}
    />
  );
};
